/* eslint-disable default-param-last */
export const types = {
  GET_TEST_VERSION_SAM: 'SAM/GET_TEST_VERSION_SAM',
  GET_TEST_VERSION_SAM_SUCCESS: 'SAM/GET_TEST_VERSION_SAM_SUCCESS',
  GET_TEST_VERSION_SAM_ERROR: 'SAM/GET_TEST_VERSION_SAM_ERROR',
};
export const actions = {
  getTestVersionSam: (data) => ({
    type: types.GET_TEST_VERSION_SAM,
    payload: { data },
  }),
  getTestVersionSamSuccess: (data) => ({
    type: types.GET_TEST_VERSION_SAM_SUCCESS,
    payload: { data },
  }),
  getTestVersionSamError: (data) => ({
    type: types.GET_TEST_VERSION_SAM_ERROR,
    payload: { data },
  }),
};

const initialState = {
  testVersion: null,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.GET_TEST_VERSION_SAM_SUCCESS: {
      const { data } = { ...action.payload };
      const { result } = { ...data };
      return {
        ...state,
        testVersion: result || 'A',
      };
    }
    case types.GET_TEST_VERSION_SAM_ERROR: {
      const { data } = { ...action.payload };
      const { result } = { ...data };
      return {
        ...state,
        testVersion: result,
      };
    }
    default:
      return state;
  }
}

export default reducer;
